import React from "react";
import { Tooltip, tooltipClasses } from "@mui/material";
import { styled } from "@mui/system";

export const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} placement="bottom" classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "559",
    color: "rgba(255,255,255)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));
